export const api = {
  alarm: {
    getAlarmDetail: '/bas/alarmSafeEvent/queryResult.json', // 获取告警详情
    getAlarmPageList: '/bas/alarmSafeEvent/queryResultsByPage.json'
  },
  historyAlarm: {
    sreachAlarm: '/bas/safeEvent/sreachAlarmDetails.json', // 历史告警筛选
    exportAlarm: '/bas/safeEvent/exportHistoryAlarm.json', // 导出历史告警
    //摄像头配置任务记录
    queryControlTaskCamera: '/vas/controltask/queryControlTaskCamera.json'
  },
  bas: {
    getAlarmTypeAndSubsystem: '/bas/alarmSafeEvent/queryAlarmTypeAndSubsystem.json', //获取子系统及高级类型级联数据
    getTaskDetail: '/bas/taskcenter/queryTaskInfo.json', // 查看任务详情
    picStreamInfo: '/bas/safeEvent/picStreamInfo.json',
    queryLinkedDevList: '/bas/linkage/queryLinkedDevList.json',
    exportAlarm: '/bas/safeEvent/exportHistoryAlarm.json' // 导出历史告警
  },
  cms: {
    getArea: '/cms/area/queryAreaByAccountName.json' // 查询关联区域
  }
}